export enum NutritionStandardKey {
  STANDARD_PLG_DAY = 'standardPlgDay',
  STANDARD_ENERGY_DISTRIBUTION = 'standardEnergyDistribution',
  STANDARD_PLG_BREAKFAST = 'standardPlgBreakfast',
  STANDARD_PLG_LUNCH = 'standardPlgLunch',
  STANDARD_PLG_AFTERNOON = 'standardPlgAfternoon',
  STANDARD_PLG_DINNER = 'standardPlgDinner',
  STANDARD_PLG_EXTRA1 = 'standardPlgExtra1',
  STANDARD_PLG_EXTRA2 = 'standardPlgExtra2',
  STANDARD_FRUIT = 'standardFruit',
  STANDARD_VEGETABLE = 'standardVegetable',
  STANDARD_SALT = 'standardSalt',
  STANDARD_MEALS_PER_DAY = 'standardMealsPerDay'
}

export enum MealMode {
  BREAKFAST = 'Bs',
  LUNCH = 'Btr',
  AFTERNOON_MEAL = 'Bc',
  DINNER = 'Bt',
  EXTRA_MEAL_1 = 'BP_1',
  EXTRA_MEAL_2 = 'BP_2',
  ALL = 'ALL',
  EXTRA_MEAL = 'Bp',
  STRUCT = 'Struct',
  DAY = 'Day'

}

export enum UnitMode {
  P = 'P', // Protein
  L = 'L', // Lipid
  G = 'G' // Glucid
}
